import React, { useMemo } from "react";
import { Constants, useMeeting, useParticipant } from "@videosdk.live/react-sdk";
import { MemoizedParticipantGrid } from "../../components/ParticipantGrid";

function WebinarParticipantsViewer({ isPresenting }) {
    const {
        participants,
        pinnedParticipants,
        activeSpeakerId,
        localParticipant,
        localScreenShareOn,
        presenterId,
    } = useMeeting();

    const participantIds = useMemo(() => {
        // Filter participants to only include those in SEND_AND_RECV mode (presenters)
        const allParticipantIds = [localParticipant.id, ...participants.keys()];
        const presenterIds = allParticipantIds.filter((participantId) => {
            const participant = participants.get(participantId);
            // Include local participant or participants in CONFERENCE mode
            return (
                participantId === localParticipant.id ||
                participant?.mode === Constants.modes.SEND_AND_RECV
            );
        });

        const pinnedParticipantId = [...pinnedParticipants.keys()].filter(
            (participantId) => {
                const participant = participants.get(participantId);
                return (
                    participantId !== localParticipant.id &&
                    participant?.mode === Constants.modes.SEND_AND_RECV
                );
            }
        );

        const regularParticipantIds = presenterIds.filter(
            (participantId) => {
                return (
                    ![...pinnedParticipants.keys()].includes(participantId) &&
                    localParticipant.id !== participantId
                );
            }
        );

        // Only show presenters (SEND_AND_RECV mode participants)
        const ids = [
            ...(localParticipant.mode === Constants.modes.SEND_AND_RECV
                ? [localParticipant.id]
                : []),
            ...pinnedParticipantId,
            ...regularParticipantIds,
        ];

        if (activeSpeakerId) {
            const activeSpeaker = participants.get(activeSpeakerId);
            if (
                !ids.includes(activeSpeakerId) &&
                activeSpeaker?.mode === Constants.modes.SEND_AND_RECV
            ) {
                ids[ids.length - 1] = activeSpeakerId;
            }
        }

        return ids;
    }, [
        participants,
        activeSpeakerId,
        pinnedParticipants,
        presenterId,
        localScreenShareOn,
        localParticipant,
    ]);

    return (
        <MemoizedParticipantGrid
            participantIds={participantIds}
            isPresenting={isPresenting}
        />
    );
}

const MemorizedWebinarParticipantView = React.memo(
    WebinarParticipantsViewer,
    (prevProps, nextProps) => {
        return prevProps.isPresenting === nextProps.isPresenting;
    }
);

export default MemorizedWebinarParticipantView;

